import {
  DELETE_PRE_PROCESSED_DOCUMENT_REQUEST,
  GET_PRE_PROCESSED_DOCUMENTS_REQUEST,
} from './types';

export const getPreProcessedDocuments = (payload) => ({
  type: GET_PRE_PROCESSED_DOCUMENTS_REQUEST,
  payload,
});

export const deletePreProcessedDocument = (payload) => ({
  type: DELETE_PRE_PROCESSED_DOCUMENT_REQUEST,
  payload,
});
